
if ($('.newrepairoptionsbutton')) {

    if ($(window).width() < 960) {
      $('.newrepairoptionsbutton').removeClass('active');
    }
    function repairOption(highlightbutton, showthisoption) {

      // console.log("repairOption fires "+highlightbutton+" #"+showthisoption);
      $('.newrepairoptionsbutton').removeClass('active');
      $('.newrepairoptions').hide();
      $('#' + showthisoption).show();
      $('#' + highlightbutton).addClass('active');
      if ($(window).width() < 960) {
        document.querySelector('#mobilescrollto').scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }
  if ($('#mostpopular-slide').length) {
    //console.log("oledlcdimages found");
    $('#mostpopular-slide').slick({
      dots: false,
      arrows: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            infinite: true,
            autoplay: true
          }
        }
      ]
    });
  }

  if ($('#ourbestdealscon-slide').length) {
    //console.log("oledlcdimages found");
    $('#ourbestdealscon-slide').slick({
      dots: false,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            infinite: true,
            autoplay: true
          }
        }
      ]
    });
  }

  if ($('#usps-slide').length) {
    //console.log("oledlcdimages found");
    $('#usps-slide').slick({
      dots: false,
      arrows: false,
      slidesToShow: 7,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true
          }
        }
      ]
    });
  }
  (function (e) {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
        $('#scroll-container').addClass('purple-bar-top');
      } else {
        $('#scroll-container').removeClass('purple-bar-top');
      }
    });
  })(jQuery)

  if ($('#oledlcdimages').length) {
    //console.log("oledlcdimages found");
    $('#oledlcdimages').slick({
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000
    });
  } else {
    //console.log("oledlcdimages not found");
  }
  $('.galaxys').slick({
    dots: false,
    arrows: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    autoplay: false,
    arrows: true,
    autoplaySpeed: 5000,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      }
    ]
  });

  $('.products-container').slick({
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    arrows: true,
    autoplaySpeed: 5000,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  function expandthis(toexpand) {
    console.log("expandthis runs " + toexpand);
    $("." + toexpand).toggleClass('expandthis');
  }
  $('.expandarrow').click(function () {
    $(this).toggleClass("expand");
  });